// extracted by mini-css-extract-plugin
module.exports = {"iframe":"_30hk2","iframeError":"_1dvNp","error":"_2HI6F"};